import { Client } from "@xmpp/client"
import { Element } from "@xmpp/xml"
import { getAllItems } from "./PubSub"
import { JID } from "@xmpp/jid"
import XmppPubSubApi from "../xmppPubSubApi"
import OpenclawWorkflowsParser, {
  WORKFLOWS_NODE,
} from "@/lib/openclawWorkflowsParser"
import { parseFleetReminders } from "@/lib/fleetReminderParser"
import { WorkflowJob } from "@/reducers/openclawWorkflowsSlice"

const transchatJid = (xmpp: Client) =>
  `transchat@${(xmpp.jid! as unknown as JID).getDomain()}`

export const subscribeToWorkflows = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(client, transchatJid(client), WORKFLOWS_NODE)
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error subscribing to ${WORKFLOWS_NODE}`, error)
    }
  }
}

export const retrieveAllWorkflows = async (
  xmpp: Client,
): Promise<WorkflowJob[]> => {
  try {
    const result = await getAllItems({
      xmpp,
      jid: transchatJid(xmpp),
      node: WORKFLOWS_NODE,
      timeout: 4000,
    })

    const items = result
      .getChild("pubsub")
      ?.getChild("items")
      ?.getChildren("item") as Element[] | undefined

    if (!items) return []

    return items.flatMap((item) => [
      ...OpenclawWorkflowsParser.parseItem(item),
      ...parseFleetReminders(item),
    ])
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      console.warn(`Error fetching ${WORKFLOWS_NODE}`, error)
    }
    return []
  }
}
